// Shrinks the floating site header (site-header.hbs / letterhead.css)
// once the page has scrolled past a small threshold, back to full size
// near the top. CSS owns the actual sizes via the .is-compact class;
// this just tracks scroll position.

export default function headerScroll() {
    const header = document.querySelector(".site-letterhead");
    if (!header) {
        return;
    }

    const THRESHOLD = 40;

    const update = () => {
        header.classList.toggle("is-compact", window.scrollY > THRESHOLD);
    };

    update();
    window.addEventListener("scroll", update, { passive: true });
}
